import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
import { useLocation } from 'react-router-dom';
import { MEMBER_WALLET_PATH, WALLET_DESTINATIONS } from '../../components/layout/navItems';
import { useTranslation } from 'react-i18next';
import { WalletCatalogSections } from './WalletCatalogSections';

export default function WalletConfigPage() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const destination =
    WALLET_DESTINATIONS.find(
      ({ section }) => pathname.replace(/\/+$/, '') === `${MEMBER_WALLET_PATH}/${section}`,
    ) ?? WALLET_DESTINATIONS[1];
  return (
    <AdminPage
      className="admin-page-body"
      header={<AdminPageHeader title={t(destination.label)} />}
    >
      <WalletCatalogSections activeSection={destination.section} />
    </AdminPage>
  );
}
